export const SELECTED_ORG_ID = 'selectedOrganisationId';
export const SELECTED_ORG_NAME = 'selectedOrganisationName';
